module.exports = "https://pearup-project-assets.s3.eu-central-1.amazonaws.com/scratch/assets/aea5158bdd395199d39d9776f8d6e43c.png";